
import React from "react";

const DEFAULT_BENEFITS = [
  "Learn at your own pace", 
  "Access to all materials", 
  "Practical exercises",
  "Lifetime access to course content"
];

export const CourseDetailBenefits = ({
  benefits
}: { benefits?: string[] }) => (
  <ul className="list-disc ml-6 space-y-1 text-gray-700">
    {(benefits ?? DEFAULT_BENEFITS).map((item, i) => (
      <li key={i}>{item}</li>
    ))}
  </ul>
);
